/// <reference path="../../dto/com.rico.sb2.service.system.ts" />

import {AppConfig} from "../../AppConfig";
import {createHtmlElement} from "../../lib/domFunctions";
import {PeriodicTask} from "../../lib/PeriodicTask";
import {Messages} from "../../messages/Messages";
import {WebSocketClient} from "../../WebSocketClient";
import JournalListItem = com.rico.sb2.service.system.JournalListItem;
import {createJournalEventElement, journalLevelOrdinalOrDefault, updateJournalEventsAgo} from "../../JournalEventView";
import {DashboardWidget, DashboardWidgetContext} from "./DashboardWidget";

const messages = new Messages();

const EVENTS_LIMIT = 100;

export class JournalWidget implements DashboardWidget {
	static readonly ID = 'journal'

	readonly id = JournalWidget.ID
	readonly element: HTMLElement

	private readonly minLevel: string
	private readonly listElement: HTMLElement
	private readonly listEmpty: HTMLElement
	private readonly agoTimer: PeriodicTask
	private subscription: ReturnType<WebSocketClient['subscribe']> | null = null

	constructor(context: DashboardWidgetContext, content: HTMLElement) {
		this.minLevel = AppConfig.eventDisplayMinimumLevel || 'INFO'

		this.element = createHtmlElement('div', {class: 'dashboard-widgets__journal'})
		this.listElement = createHtmlElement('ul', {class: 'list-unstyled m-0 px-2'})
		this.listEmpty = createHtmlElement('div', {class: 'text-muted fst-italic text-center p-3'},
			`${messages.get('JournalWidget.emptyListMessage')}`)
		this.element.append(this.listEmpty)
		this.element.append(this.listElement)
		content.append(this.element)

		this.subscription = WebSocketClient
			.instance()
			.subscribe('/topic/journal', m => this.onEvent(m))

		this.agoTimer = new PeriodicTask(() => updateJournalEventsAgo(this.listElement), {periodMs: 30000, enabled: true})
	}

	private onEvent(m: JournalListItem) {
		if (journalLevelOrdinalOrDefault(m.level) < journalLevelOrdinalOrDefault(this.minLevel))
			return;

		this.listEmpty.remove()
		this.listElement.prepend(createJournalEventElement(m));

		while (this.listElement.childElementCount > EVENTS_LIMIT) {
			this.listElement.children.item(this.listElement.children.length - 1)?.remove();
		}
	}

	dispose() {
		this.subscription?.unsubscribe()
		this.subscription = null
		this.agoTimer.enabled = false
		this.element.remove()
	}
}
